import type { VietnamProvince } from '../services/vietnam-address.service';

/** Shape aligned with VirtualWarehousePageListComponent searchParams. */
export interface VirtualWarehousePageSearchFields {
  name?: string;
  code?: string[];
  typeCodes?: string[];
  cityCode?: number;
  cityName?: string;
  page: number;
  size: number;
}

export function normalizeVirtualWarehousePageForm(
  formValue: Record<string, unknown>,
  currentSize: number,
): VirtualWarehousePageSearchFields {
  const name = (formValue['name'] as string)?.trim();
  const codeRaw = formValue['code'];
  const code = Array.isArray(codeRaw)
    ? (codeRaw as string[]).filter(Boolean).map((c) => String(c).trim())
    : codeRaw != null && String(codeRaw).trim()
      ? [String(codeRaw).trim()]
      : undefined;
  const typeCodes = (formValue['typeCodes'] as string[] | undefined)?.filter(
    Boolean,
  );
  const cityCodeRaw = formValue['cityCode'];
  const parsedCityCode =
    cityCodeRaw != null && !Number.isNaN(Number(cityCodeRaw))
      ? Number(cityCodeRaw)
      : undefined;
  const cityCode =
    parsedCityCode !== undefined && parsedCityCode !== 0
      ? parsedCityCode
      : undefined;

  return {
    name: name || undefined,
    code: code?.length ? code : undefined,
    typeCodes: typeCodes?.length ? typeCodes : undefined,
    cityCode,
    cityName: undefined,
    page: 0,
    size: currentSize,
  };
}

export function virtualWarehousePageHasActiveFilters(
  current: Pick<
    VirtualWarehousePageSearchFields,
    'name' | 'code' | 'typeCodes' | 'cityCode'
  >,
): boolean {
  return !!(
    current.name ||
    current.code?.length ||
    current.typeCodes?.length ||
    current.cityCode != null
  );
}

export function virtualWarehousePageResetFields(
  currentSize: number,
): Pick<VirtualWarehousePageSearchFields, 'page' | 'size'> {
  return { page: 0, size: currentSize };
}

export function resolveCityNameForVirtualPageApi(
  cityCode: number | undefined | null,
  provinces: VietnamProvince[],
  lang: string,
): string | undefined {
  if (cityCode == null) return undefined;
  const province = provinces.find((p) => p.id === cityCode);
  if (!province) return undefined;
  return lang === 'vi' ? province.full_name : province.full_name_en;
}

export interface VirtualPagePaginationEvent {
  page?: number;
  rows?: number;
  first?: number;
}

export function mergeVirtualWarehousePagePagination(
  current: { page: number; size: number },
  event: VirtualPagePaginationEvent,
): { page: number; size: number } {
  const rows = event.rows ?? current.size;
  const page =
    event.page ??
    (event.first != null && rows > 0 ? Math.floor(event.first / rows) : 0);
  return { page, size: rows };
}
